import type { PatternBased, RuleAction, RuleBased } from '@kkp-fraud/shared';
import { branchesOf, patternBranchesOf } from '../branches';
import { formatBranches } from '../format';
import { ActionChip } from './Chips';

/**
 * Every action row of a rule as `[ActionChip] condition`, top to bottom in row order.
 * `formatBranches` leaves `action` null on a one-row rule, so the chip comes from the rows
 * themselves — both lists are one entry per row.
 */
export function actionConditionPairs(rule: RuleBased | PatternBased): { action: RuleAction; condition: string }[] {
  const rows = 'clauses' in rule ? branchesOf(rule) : patternBranchesOf(rule);
  const lines = formatBranches(rule);
  return rows.map((row, i) => ({ action: row.action, condition: lines[i]?.condition ?? '' }));
}

export function ActionConditionList({ rule, testid }: { rule: RuleBased | PatternBased; testid?: string }) {
  return (
    <div className="ac-list" data-testid={testid}>
      {actionConditionPairs(rule).map((pair, i) => (
        <div key={i} className="ac-row" data-testid={testid ? `${testid}-row` : undefined}>
          <ActionChip action={pair.action} />
          <span className="mono ac-cond">{pair.condition}</span>
        </div>
      ))}
    </div>
  );
}
